import type { SVGProps } from 'react'
const SvgCopyId = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    width={24}
    height={24}
    fill='none'
    {...props}
  >
    <path d='M5.75 3A2.75 2.75 0 0 0 3 5.75v7.596c0 1.04.578 1.944 1.432 2.41.441.241.902-.147.902-.65 0-.349-.243-.644-.484-.895a1.242 1.242 0 0 1-.35-.865V5.75c0-.69.56-1.25 1.25-1.25h7.623c.335 0 .64.132.863.348.251.24.543.482.89.482.505 0 .897-.46.655-.902A2.743 2.743 0 0 0 13.373 3zM10 7a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3zm.965 2.5c.532 0 .963.432.963.965v7.07a.964.964 0 1 1-1.928 0v-7.07c0-.532.433-.965.965-.965m3.914.115a1.01 1.01 0 0 1 .254.026c.235.052.466.12.691.2a5.255 5.255 0 0 1 1.67.977 4.51 4.51 0 0 1 1.115 1.46c.259.545.391 1.131.391 1.722l-.006.22a4.037 4.037 0 0 1-.385 1.503 4.512 4.512 0 0 1-1.115 1.459 5.25 5.25 0 0 1-1.67.974 5.7 5.7 0 0 1-.691.203c-.693.156-1.276-.434-1.276-1.144v-6.43c0-.621.446-1.15 1.022-1.17zm.906 2.137v4.492a2.818 2.818 0 0 0 1.041-1.168c.162-.341.246-.707.246-1.076s-.084-.735-.246-1.076a2.82 2.82 0 0 0-.695-.912 3.18 3.18 0 0 0-.346-.26' />
  </svg>
)
export default SvgCopyId
